import script from "./CRM60_007INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM60_007INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__